export enum OrderAssemblyState {
  PedidoRecebidoMontagem = 1,
  PedidoIniciadoMontagem = 2,
  PedidoConcluidoMontagem = 3,
  PedidoEnviadoLoja = 4
}